<template>
  <div>
    <b-form inline @submit.prevent="" class="mb-2">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text class="semester-input-group">
          Start
        </b-input-group-prepend>
        <b-form-select v-model="termStart"
                      @input="changeTerm" 
                      :options="terms"
                      value-field="termCode"
                      text-field="description"
                      />
      </b-input-group>

      <b-input-group class="filter-group">
        <b-input-group-prepend is-text class="semester-input-group">
          End
        </b-input-group-prepend>
        <b-form-select v-model="termEnd"
                      @input="changeTerm" 
                      :options="terms"
                      value-field="termCode"
                      text-field="description"
                      />
      </b-input-group>
    </b-form>
    <div>
      <a :href="csvUrl">Download CSV</a>
    </div>
    <!-- table goes here -->
     <b-table :items="items" :fields="fields">
      <template slot="studentName" slot-scope="data">
        {{ data.item.firstName }} {{ data.item.lastName }}
      </template>
      <template slot="startDate" slot-scope="data">
        {{ data.item.startDate | formatDate }}
      </template>
      <template slot="endDate" slot-scope="data">
        {{ data.item.endDate | formatDate }}
      </template>
      <template slot="ilaApprovalDate" slot-scope="data">
        {{ data.item.ilaApprovalDate | formatDate }}
      </template>
    </b-table>
  </div>
</template>
<script>
import termsApi from "../../api/terms";
import studentOpportunityApi from "../../api/studentOpportunity";
export default {
  data() {
    return {
      termStart: null,
      termEnd: null,
      terms: [], // This should be populated with term options
      items: [], // This should be populated with the data for the bar chart

      fields: [
        { key: "asuriteId", label: "AsuriteID" },
        { key: "studentName", label: "Student Name" },
        { key: "homeStateCode", label: "Home State" },
        { key: "homePostalCode", label: "Home Zipcode" },
        { key: "academicPlan", label: "Academic Plan" },
        { key: "academicPlanDescription", label: "Plan Description" },
        { key: "subjectCode", label: "Subject" },
        { key: "catalogNumber", label: "Catalog Number" },
        { key: "gradeFinal", label: "Grade" },
        { key: "divider", label: "" },
        { key: "termCode", label: "Term Code" },
        { key: "termDescription", label: "Term Description" },
        { key: "siteName", label: "Site" },
        { key: "opportunityName", label: "Opportunity Name" },
        { key: "streetAddress", label: "Street Address" },
        { key: "state", label: "State" },
        { key: "zip", label: "Zipcode" },
        { key: "opportunityType", label: "Type" },
        { key: "opportunityCategory", label: "Category" },
        { key: "startDate", label: "Start Date" },
        { key: "endDate", label: "End Date" },
        { key: "ilaApprovalDate", label: "ILA Approval Date" },
      ],
    };
  },
  methods: {
    changeTerm() {
      if (this.termStart && this.termEnd) {
        this.getData();
      }
    },
    getData() {
      studentOpportunityApi
        .getApprovedStudentOpportunitiesByTerms(this.termStart, this.termEnd)
        .then((response) => {
          this.items = response.data;
        });
    },
  },
  computed: {
    csvUrl() {
      return (
        process.env.VUE_APP_BASE_URI +
        "/api/StudentOpportunities/approved-students/csv?startStrm=" +
        this.termStart +
        "&endStrm=" +
        this.termEnd
      );
    },
  },
  created() {
    termsApi.getPastTerms().then((response) => {
      this.terms = response.data;
    });
    // this.getData();
  },
};
</script>
